import { useEffect, useState } from 'react';
import { navLinks } from '../data/content';
import Logo from './Logo';
import './Header.css';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`header${scrolled ? ' header--scrolled' : ''}`}>
      <a href="#inicio" className="header__brand">
        <Logo size={34} className="header__mark" />
        <span className="header__wordmark">
          <span className="header__eyebrow">CENTRO DE ENTRENAMIENTO</span>
          <span className="header__name">KAMAE</span>
        </span>
      </a>
      <nav className="header__nav">
        {navLinks.map((link, i) => (
          <a
            key={link.href}
            href={link.href}
            className={`header__link${i === 0 ? ' header__link--active' : ''}`}
          >
            {link.label}
          </a>
        ))}
        <a href="/ingresar" className="header__link header__link--estudiantes">
          Estudiantes
        </a>
        <a href="#contacto" className="header__cta">
          Contacto
        </a>
      </nav>
    </header>
  );
}